import { render } from "./filterChallenge.html?vue&type=template&id=08a469ce"
import script from "./FilterChallenge.vue?vue&type=script&lang=ts"
export * from "./FilterChallenge.vue?vue&type=script&lang=ts"

import "./filterChallenge.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script